import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "template"];

  add(event) {
    event.preventDefault();
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime());
    this.containerTarget.insertAdjacentHTML("beforeend", html);
  }

  remove(event) {
    event.preventDefault();
    const row = event.target.closest("[data-nested-fields-target='container'] > *");
    if (!row) return;

    const destroyField = row.querySelector('input[type="hidden"][name*="[_destroy]"]');
    if (destroyField) {
      destroyField.value = "1";
      row.style.display = "none";
    } else {
      row.remove();
    }
  }
}
